<template>
  <div class="content">
    <div class="module-txt">曲率K1</div>
    <div class="module-input">
      <div>右眼<input type="number" v-model='info.rk1' placeholder='请输入数据' /></div>
      <div>左眼<input type="number" v-model='info.lk1' placeholder='请输入数据' /></div>
    </div>
    <div class="module-txt">曲率K2</div>
    <div class="module-input">
      <div>右眼<input type="number" v-model='info.rk2' placeholder='请输入数据' /></div>
      <div>左眼<input type="number" v-model='info.lk2' placeholder='请输入数据' /></div>
    </div>
    <div class="module-txt">年龄</div>
    <div class="module-input">
      <div><input class="input-big" type="number" v-model='info.age' placeholder='请输入数据' /></div>
    </div>
    <div class="module-txt">实际眼轴长度</div>
    <div class="module-input">
      <div>
        <p>右眼</p>
        <p><input class="input-small" type="number" v-model='info.rAxialLength' placeholder='请输入数据' /> mm</p>
      </div>
      <div>
        <p>左眼</p>
        <p><input class="input-small" type="number" v-model='info.lAxialLength' placeholder='请输入数据' /> mm</p>
      </div>
    </div>
    <van-button type="info" @click="goCulate2" class="calculate-btn">计算</van-button>
    <div class="module-txt">近视临界点眼轴长度</div>
    <div class="module-input">
      <div>
        <p>右眼</p>
        <p><input class="input-small" type="number" v-model='rkAvg' readOnly /> mm</p>
      </div>
      <div>
        <p>左眼</p>
        <p><input class="input-small" type="number" v-model='lkAvg' readOnly /> mm</p>
      </div>
    </div>

    <div class="info" v-if="showInfo">
      <div class="module-txt">计算结果</div>
      <div class="result">
        <div>右眼</div>
        <div class="result-info">
          <p>预计当前屈光度约为{{ rqgd }}D(±0.5D)</p>
          <p>{{ rpdts }}</p>
        </div>
      </div>
      <div class="result">
        <div>左眼</div>
        <div class="result-info">
          <p>预计当前屈光度约为{{ lqgd }}D(±0.5D)</p>
          <p>{{ lpdts }}</p>
        </div>
      </div>
      <div class="remark">注：-为近视，+为远视，此为等效球镜的理论平均值，存在个体差异，数值仅供参考</div>
    </div>
  </div>
</template>
<script lang="script">
export default {
  name: 'checkin',
  data() {
    return {
      isDisable: true,
      showInfo: false,
      info: {
        lk1:'',
        lk2:'',
        rk1:'',
        rk2:'',
        age: '',
        rAxialLength:'',
        lAxialLength:'',
        auth: '',
        time: ''
      },
      lkAvg: '',
      rkAvg: '',
      lpdts:'',
      rpdts:'',
      lqgd:'',
      rqgd:''
    }
  },
  mounted() {
    document.title = '曲率计算';
    this.info.auth = this.$pauth;
    this.info.time = this.$ptime;
  },
  methods: {
      /*let auth =this.$createAuth(this.$md5);
      let data = {
        lk1: this.info.lk1,
        lk2: this.info.lk2,
        rk1: this.info.rk1,
        rk2: this.info.rk2,
        age: this.info.age,
        auth: auth.code,
        time: auth.time
      }
      let result = await this.$http.post(this.$url.saveCalculateK,data);
      this.rkAvg = result.data.map.rk;
      this.lkAvg = result.data.map.lk;
      this.isDisable = false;
    },*/
    async goCulate2() {
      let auth =this.$createAuth(this.$md5);
      this.info.auth = auth.code;
      this.info.time =auth.time;
      let result = await this.$http.post(this.$url.saveCalculateK,this.info);
      this.lpdts = result.data.map.lpdts;
      this.rpdts = result.data.map.rpdts;
      this.lqgd = result.data.map.lqgd;
      this.rqgd = result.data.map.rqgd;
      this.rkAvg = result.data.map.rk;
      this.lkAvg = result.data.map.lk;
      this.showInfo = true;
    },
  }
}
</script>
<style lang="less" scoped>
.content {
  padding: 0.3rem;
}

.module-txt {
  font-weight: bold;
  font-size: 0.32rem;
  text-align: left;
}

.module-input {
  display: flex;
  width: 100%;

  div {
    width: 3.3rem;
    margin: 0.2rem 0.3rem 0.3rem 0;
    text-align: left;
    font-size: 0.28rem;

    p {
      width: 3.3rem;
    }

    input {
      width: 3.3rem;
      margin-top: 0.2rem;
      padding: 0.15rem 0.1rem;
      box-sizing: border-box;
      border: 1px solid #ccc;
      border-radius: 0.05rem;

      &.input-big {
        width: 6.9rem;
        margin-top: 0;
      }

      &.input-small {
        width: 2.5rem;
      }
    }

  }
}

.calculate-btn {
  width: 6.9rem;
  margin: 0 0 0.5rem;
  border: none;
  background: #5CC4AB;
}

.calculate-btn-disable {
  width: 6.9rem;
  margin: 0 0 0.5rem;
  border: none;
  color: #ccc;
  background: #eee;
}

.result {
  margin: 0.3rem 0;
  text-align: left;

  .result-info {
    margin: 0.3rem 0;
    padding: 0.15rem;
    border: 1px solid #ddd;
    border-radius: 0.05rem;

    p {
      margin-bottom: 0.2rem;
    }
  }
}

.remark {
  margin: 0.3rem 0;
  text-align: left;
  color: #666;
}</style>
